import type { TCreateContentReport, TError } from '@onesource/schemas';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

export type TReportContentTarget = 'post' | 'comment';

const REPORT_PATH: Record<TReportContentTarget, string> = {
  post: 'posts',
  comment: 'comments',
};

/**
 * Hook to report a post or a comment (reply) to moderators
 *
 * @param targetType - Whether the target is a post or a comment
 * @param targetId - Post / comment ID (UUID)
 */
export const useReportContent = (targetType: TReportContentTarget, targetId: string) =>
  useMutation<void, TError, TCreateContentReport>({
    mutationFn: async data => {
      await axios.post(`/community-hub/${REPORT_PATH[targetType]}/${targetId}/report`, data);
    },
  });
